import React, { Component } from 'react';
import {Drawer, Grid, Hidden, Icon, Typography} from '@material-ui/core';
import {webFont} from "../../config/theme";

export default class BookingSlider extends Component {

  handleToggle=()=>{
    if(this.props.step === 1){
      this.props.handleToggle();
    }else{
      let step=this.props.step -1;
      this.props.changeProgressStep(step);
    }
}

  render() {
    return (<div>
      <Hidden only={['xs']}>
        <Drawer anchor={'right'} open={this.props.toggleDrawer}>
          <div style={{ width: 480, padding: '27px 20px 50px', boxSizing: 'border-box' }}>
            <Grid container>
              <Grid item xs={12} >
                <Icon onClick={()=>{this.handleToggle()}}>{this.props.step === 1 ? "clear" : "keyboard_arrow_left"}</Icon>
              </Grid>
              <Grid item xs={12} >
                  <Typography style={{...styles.setFont, ...{ fontSize: 14, margin: '10px 0' }}}>
                      Step {this.props.step} of 5
                  </Typography>
              </Grid>
            </Grid>
            {this.props.children}
          </div>
        </Drawer>
      </Hidden>
      <Hidden only={['sm', 'md', 'lg', 'xl']}>
        <Drawer anchor={'right'} open={this.props.toggleDrawer}>
          <div style={[{ width: 480, paddingLeft: 20 }]}>
            <Grid container>
              {/*<Grid item xs={12} style={[{ marginBottom: 25 }]}>*/}
                <Grid item xs={12} >

                <Icon onClick={()=>{this.handleToggle()}}>{this.props.step === 1 ? "clear":"keyboard_arrow_left"}</Icon>
              </Grid>
              <Grid item xs={12} >
                <Typography style={{...styles.setFont, ...{ fontSize: 14 }}}>
                  Step {this.props.step} of 5
                </Typography>
              </Grid>
            </Grid>
            {this.props.children}
          </div>
        </Drawer>
      </Hidden>
    </div>);
  }
}


const styles= {
  setFont:{
      fontFamily: webFont
  },
};
